<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
onMounted(() => {

})
const props = defineProps({
    title: {
        type: String,
    },
    url: {
        type: String,
    },
});

const goBack = () => {
    if(props.url){
        console.log('props.url',props.url)
        router.push(props.url);
    }else{
        router.go(-1);
    }
}
</script>
<template>
    <div class="top">
        <div class="divcontent">
            <div @click="goBack()"><img src="../../assets/images/return1.png" alt="" srcset="" style="width: 22px;height: 18px;"></div>
            <div>{{ props.title }}</div>
            <div> </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
@media (max-width: 768px) {
    .top {
        top: 0;
        position: fixed;
            background: #fff;
            width: 100%;
            height: 45px;
            z-index: 9999;
            // padding: 0 20px;
        .divcontent {
            padding: 10px 15px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #222222;
            line-height: 25px;
            text-align: right;
            font-style: normal;
            display: flex;
            justify-content: space-between;
            /* padding: 13px 0; */
            // height: 50px;
            align-items: center;
            
        }

    }
}
</style>
